import React, {useState} from 'react';
import {
    TextInput,
    DateInput,
    SelectInput,
    Create,
    SimpleForm,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Notification,
    
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import { Redirect } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';

let ssn = null;
let deferral_code = null;
let deferral_comments = null;
let deferral_date = null;
let deferral_exp_date = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const SPEEditActions = ({props}) => (
     ssn = (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn,
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/spe?filter=%7B"ssn"%3A"' + ssn + '"%2C"deferral_code"%3A"' + deferral_code + '"%2C"deferral_date"%3A"' +
          deferral_date + '"%2C"deferral_exp_date"%3A"' + deferral_exp_date +  '"%2C"deferral_comments"%3A"' +
          deferral_comments + '"%7D&order=DESC&page=1&perPage=25&sort=id'} label='SPE List'/>
    </CardActions>
);

const editStyles = {
    root: { alignItems: 'flex-start'},
    initial: {  width: '5em' },
    booth: {  width: '2em' },
    time: {  width: '7em' },
    volume: {  width: '3em' },
    comments: {  width: '30em' },
};

const action = [
    {
        id: 'Approved',
        name: 'Approved'
    },
    {
        id : 'Defer Donor',
        name: 'Defer Donor'
    },
    {
        id : 'Draw New Sample',
        name: 'Draw New Sample'
    }
  ]
  
  const deferralCodes = [

    {
        id: 'PR',
        name: 'Permanently Rejected'
    },
    {
        id : 'ID',
        name: 'Indefinitely Deferred'
    },
    {
        id : 'TD',
        name: 'Temporarly Deferred'
    },
    {
        id: 'N/A',
        name: 'Not Applicable'
    }
  ]

  
const SEPToolbar = props => (
    <Toolbar {...props} >
        {ssn = (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn }
        <SaveButton
            label="save"
            redirect={'/spe?filter=%7B"ssn"%3A"' + ssn +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
            submitOnEnter={true}
        />
    </Toolbar>
);

const GetKey=({ props }) => (
    ssn = (props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn,
    deferral_code =  (props.location && props.location.deferral_code)? props.location.deferral_code:deferral_code,
    deferral_date= (props.location && props.location.deferral_date)? props.location.deferral_date:deferral_date,
    deferral_exp_date= (props.location && props.location.deferral_exp_date)? props.location.deferral_exp_date:deferral_exp_date,
    deferral_comments= (props.location && props.location.deferral_comments)? props.location.deferral_comments:deferral_comments,
    (ssn)? '': <Redirect to="/donors" />
);

const SpeCreate =({ classes, ...props }) => (
<ErrorBoundary>  
<Create 
    title='SPE Add' 
    {...props}  
    actions={<SPEEditActions props={props}/>} 
    >
   <SimpleForm toolbar={<SEPToolbar />}> 
   { console.log(props)}
   <table  cellPadding={8} style={{width: '100%'}}>
       <tbody>
           <tr>
               <td><SanitizedTextInput source="ssn" defaultValue={(props.location)?( (props.location.ssn)?props.location.ssn:ssn):ssn} disabled  validate={required()} /></td>
               <td><SanitizedTextInput source="ucn" label="Unit Control Number" validate={required()} /></td>
           </tr>
           <tr>
               <td><SanitizedTextInput source="tech_init" label="Tech Initial"  validate={required()} /></td>
               <td><DateInput source="tech_date" locales="en-us" label="Tech Date"  validate={required()}/></td>
           </tr>
           
           {
            ((((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' ) == 'PHYN' || 
            (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' ) == 'PHYS') &&
            <>
            <tr>
               <td colSpan={2}><SelectInput source="ps_action"  choices={action} label="PS/CMD Action" /></td>
           </tr>
           <tr>
               <td colSpan={2}><TextInput source='comments' label="Comments for above action" multiline  maxRows={3} fullWidth/></td>
           </tr>
           <tr>
               <td> <SanitizedTextInput source="ps_init" label="PS/CMD Initial" /></td>
               <td><DateInput source="ps_date" locales="en-us" label="PS/CMD Date"/></td>
           </tr>
           <tr>
               <td colSpan={2}><DateInput source="next_date" locales="en-us" label="Next Due Date"/></td>
           </tr>
           </>
           }
           {
           (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).code : '' ) == 'QA' &&
           <>
           <tr>
               <td colSpan={2}><SelectInput source="ps_action"  choices={action} label="PS/CMD Action" disabled/></td>
           </tr>
           <tr>
               <td colSpan={2}><TextInput source='comments' label="Comments for above action" multiline  maxRows={3} fullWidth disabled/></td>
           </tr>
           <tr>
           <td> <SanitizedTextInput source="ps_init" label="PS/CMD Initial"  disabled /></td>
           <td><DateInput source="ps_date" locales="en-us" label="PS/CMD Date"   disabled /></td>
            </tr>
            <tr>
                <td colSpan={2}><DateInput source="next_date" locales="en-us" label="Next Due Date" disabled/></td>
            </tr>
           <tr>
               <td> <SanitizedTextInput source="qa_init" label="QA Initial" /></td>
               <td><DateInput source="qa_date" locales="en-us" label="QA Date"/></td>
           </tr>
           </>
           }
           <tr>
               <td colSpan={2}><SelectInput source="deferral_code"  choices={deferralCodes}  defaultValue ={props&&props.location&&props.location.deferral_code}  label="Deferral code"     /></td>
           </tr>
           <tr>
               <td><DateInput source="deferral_date"    label="Deferral date" locales="en-us"  defaultValue={(props.location)?( (props.location.deferral_date)?props.location.deferral_date: null): null} /></td>
               <td><DateInput source="deferral_exp_date"    label="Deferral Exp date" locales="en-us" defaultValue={(props.location)?( (props.location.deferral_exp_date)?props.location.deferral_exp_date: null): null}   /></td>
           </tr>
           <tr>
               <td colSpan={2}><TextInput source="deferral_comments"   maxRows={4} multiline fullWidth  label="Deferral comments"  defaultValue={(props.location)?( (props.location.deferral_comments)?props.location.deferral_comments: null): null} />
               <GetKey props={props} /> 
               </td>
           </tr>
           
       </tbody>
   </table> 
   </SimpleForm>
    </Create>
</ErrorBoundary>  
);

export default withStyles(editStyles)(SpeCreate);
